import React from "react";
import { useSearchParams } from "react-router-dom";
import CustomerStatsDisplay from "components/Stats/CustomerStatsDisplay";
import ApiKeySelect from "components/common/ApiKeySelect";
import { useCompanyContext } from "./CompanyContext";

// Stats for the whole company, or for one API key picked in the API Key dropdown.
const CompanyOverview: React.FC = () => {
  const { companyId } = useCompanyContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedApiKeyId = searchParams.get("apiKeyId") ?? "";

  const handleApiKeyChange = (value: string) =>
    setSearchParams(value ? { apiKeyId: value } : {}, { replace: true });

  return (
    <CustomerStatsDisplay
      customerId={companyId}
      apiKeyId={Number(selectedApiKeyId) || undefined}
      toolbarStart={
        <ApiKeySelect
          id="overview-api-key"
          customerId={companyId}
          value={selectedApiKeyId}
          onChange={handleApiKeyChange}
        />
      }
    />
  );
};

export default CompanyOverview;
